import { useEffect } from 'react';

import type { GenericId } from '@e-socna/data-layer';
import { ColorEnum, IconEnum } from '@e-socna/data-layer';

import { useNotificationsContext } from '../contexts/NotificationsContext/hooks/useNotificationsContext.hooks';
import { useGeolocation } from '../hooks/useGeolocation.hook';

const GEOLOCATION_NOTIF_ID = 'geolocation' as GenericId;

export const CheckGeolocation = () => {
  const { notifications, addNotification, removeNotification } =
    useNotificationsContext();
  const { error } = useGeolocation();

  useEffect(() => {
    const notificationExists = notifications.find(
      (n) => n._id === GEOLOCATION_NOTIF_ID,
    );
    if (error && !notificationExists) {
      addNotification({
        __typename: 'Notification' as const,
        _id: GEOLOCATION_NOTIF_ID,
        primaryText: 'Géolocalisation',
        secondaryText:
          'Vous devriez activer la géolocalisation pour une meilleure expérience.',
        createdAt: new Date().toISOString(),
        hasBeenRead: false,
        chip: {
          __typename: 'Chip' as const,
          color: ColorEnum.Info,
          icon: IconEnum.LocationOn,
        },
      });
    } else if (!error && notificationExists) {
      removeNotification(GEOLOCATION_NOTIF_ID);
    }
  }, [error, addNotification, notifications, removeNotification]);

  return null;
};
